export function isVisibleXs() {

    return isVisible('xs');

}

export function isVisibleSm() {

    return isVisible('sm');

}

export function isVisibleMd() {

    return isVisible('md');

}

export function isVisibleLg() {

    return isVisible('lg');

}

function isVisible(size) {

    if (document.querySelector('#pg-visible-' + size) == null) {

        let element = document.createElement('div');

        element.id        = 'pg-visible-' + size;
        element.className = 'visible-' + size;

        document.querySelector('body').appendChild(element);

    }

    return window.getComputedStyle(document.getElementById('pg-visible-' + size)).display == 'block';

}

export function getUserAgent() {

    return document.querySelector('body').classList.contains('mobile') ? 'mobile' : 'desktop';

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pages.ts